import * as React from "react";
const Component = props => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 11.667 11.667" {...props}><path xmlns="http://www.w3.org/2000/svg" fill="currentColor" d="M5 6.663H0v-1.66h5v-5h1.667v5h5v1.66h-5v5H5z" /></svg>;
export default Component;